import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { FAQS } from "../data/content";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="pt-28" data-testid="faq-page">
      <section className="mx-auto max-w-[1100px] px-5 sm:px-8 py-16">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-gold mb-4">FAQ</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-moss leading-[0.95] max-w-3xl">
            Questions, <span className="italic text-gold">answered honestly.</span>
          </h1>
        </Reveal>

        <div className="mt-14 divide-y divide-[#E4DDD0] border-y border-[#E4DDD0]">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-7 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-serif text-2xl sm:text-3xl text-moss">{f.q}</span>
                  <span className="shrink-0 text-gold">{isOpen ? <Minus className="h-5 w-5" /> : <Plus className="h-5 w-5" />}</span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 max-w-2xl text-muted leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-16 rounded-sm bg-cream-2 p-10 text-center">
            <h2 className="font-serif text-3xl text-moss">Still curious?</h2>
            <p className="mt-2 text-muted">Read every ingredient in full, from origin to actives.</p>
            <Link to="/glossary" className="btn-gold mt-6 inline-flex rounded-sm px-7 py-3.5 text-sm font-semibold uppercase tracking-wider" data-testid="faq-glossary-cta">
              Ingredient Glossary
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
